module.exports = __webpack_public_path__ + "static/media/global.0d91536b.png";